import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import NumberedStepsCarousel from '../../components/NumberedStepsCarousel';
import { getCivilIcon } from '../../components/CivilIcons';

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphSettings = useMemo(
    () => settings?.paragraphs?.[1],
    [settings?.paragraphs]
  );

  const handleMfaComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'civil-core-section1-1');
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="core-section">
      <div className="content-block content-block-steps">
        <NumberedStepsCarousel
          type="simple"
          mainTitle={paragraphSettings?.section1Title}
          description={paragraphSettings?.section1Desc}
          items={(paragraphSettings?.section1Items || []).map((item: any) => ({
            text: item.text || '',
          }))}
          defaultActive={0}
        />
      </div>
      <div className="content-block content-block-cards">
        <HighlightedCardsGrid
          mainTitle={paragraphSettings?.section2Title}
          description={paragraphSettings?.section2Desc}
          items={(paragraphSettings?.section2Items || []).map((item: any) => ({
            title: item.title || '',
            content: item.content || '',
            icon: getCivilIcon(item.icon),
          }))}
        />
      </div>
      <div className="content-block content-block-steps">
        <NumberedStepsCarousel
          type="simple"
          id="civil-core-section1-1"
          mainTitle={paragraphSettings?.section3Title}
          description={paragraphSettings?.section3Desc}
          items={(paragraphSettings?.section3Items || []).map((item: any) => ({
            text: item.text || '',
          }))}
          defaultActive={0}
          onComplete={handleMfaComplete}
        />
      </div>
    </div>
  );
};

export default Section1;
